import { render, staticRenderFns } from "./promotionMsg.vue?vue&type=template&id=420eac4e&"
import script from "./promotionMsg.vue?vue&type=script&lang=js&"
export * from "./promotionMsg.vue?vue&type=script&lang=js&"
import style0 from "./promotionMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports